import { Grid } from "@mui/material";
import { CustomTab, CustomTabs } from "../Auditoria/CustomItems";
import SingleOrgUsers from "./Users/SingleOrgUsers";
import { useSuperAdminSingleOrg } from "../../../context/SuperAdmin/SingleOrgContext";
import SingleOrgSuborgs from "./Suborg/SingleOrgSuborgs";

const TabsSingleOrg = () => {
  //Si tabValue es 0, será Usuarios. Si es 1, será Suborganizaciones
  const { tabValue, setTabValue, organization } = useSuperAdminSingleOrg();

  return (
    <Grid item>
      {/* Selección de tab Usuarios o Suborganizaciones */}
      <CustomTabs
        value={tabValue}
        onChange={(_, newValue: 0 | 1) => setTabValue(newValue)}
        variant="fullWidth"
      >
        <CustomTab label="Usuarios" />
        <CustomTab label="Suborganizaciones" />
      </CustomTabs>

      {/* Tab seleccionada. Si es 0, será Usuarios */}
      {tabValue === 0 ? <SingleOrgUsers /> : <SingleOrgSuborgs />}
    </Grid>
  );
};

export default TabsSingleOrg;
